import { DateBox } from 'devextreme-react/date-box';
import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Copy } from 'react-feather';
import { toast } from 'react-toastify';
import { Input } from 'reactstrap';
import api from '../../services/api-configuration';
import useFormatMessage from '../../utils/useFormatMessage';

const QuickActionsModal = ({ isOpen, onClose, chassisNo, onActionSuccess }) => {
    const { t } = useFormatMessage();
    const [priority, setPriority] = useState('');
    const [pdiDate, setPdiDate] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isCopied, setIsCopied] = useState(false);

    useEffect(() => {
        if (!isOpen) {
            setPriority('');
            setPdiDate(null);
        }
    }, [isOpen]);

    const handlePrioritySubmit = async () => {
        if (!priority || priority < 1 || priority > 9) {
            toast.error(t('Lütfen 1-9 arası bir öncelik puanı giriniz'));
            return;
        }

        setIsLoading(true);
        try {
            await api.post('/addPriorityByChassisNo', {
                chassis_no: chassisNo,
                priority: parseInt(priority),
                create_user_id: parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'))
            });
            toast.success(t('Öncelik başarıyla güncellendi'));
            onActionSuccess();
        } catch (error) {
            toast.error(t('Öncelik güncellenirken bir hata oluştu'));
        } finally {
            setIsLoading(false);
        }
    };

    const handlePDISubmit = async () => {
        console.log("PDI Date: ", pdiDate);
        if (!pdiDate) {
            toast.error(t('Lütfen bir tarih seçiniz'));
            return;
        }

        setIsLoading(true);
        try {
            const response = await api.post('/addPdiOrderByChassisNo', {
                "pdi_order_date": pdiDate.toISOString().split('T')[0],
                "process_type": "PDI",
                "sase": chassisNo,
                "user_id": String(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'))
            });

            if (response.data.stats.failed > 0) {
                const errorMessage = response.data.results[0]?.error || t('PDI emri oluşturulurken bir hata oluştu');
                if (errorMessage.includes('PDI status is already YENİ')) {
                    toast.error(t('PDI Emri zaten mevcut'));
                } else {
                    toast.error(errorMessage);
                }
            } else {
                toast.success(t('PDI emri başarıyla oluşturuldu'));
                onActionSuccess();
            }
        } catch (error) {
            toast.error(t('PDI emri oluşturulurken bir hata oluştu'));
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal show={isOpen} onHide={onClose} className="quick-actions-modal" size='lg'>
            <Modal.Header closeButton>
                <Modal.Title>Şase Bazlı Hızlı İşlemler</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="chassis-display mb-4 mt-2">
                    <span className="chassis-number"
                        style={{
                            fontSize: '1.2rem', fontWeight: 'bold',
                            padding: '10px',
                            backgroundColor: 'rgb(245 245 245)',
                        }}
                    >{chassisNo}

                    </span>

                    <Button
                        variant="link"
                        size="sm"
                        onClick={() => {
                            navigator.clipboard.writeText(chassisNo);
                            toast.success(t('Şase numarası kopyalandı'));
                        }}
                        style={{ padding: '0 5px', color: '#272727' }}
                    >
                        <Copy size={17} />
                    </Button>
                </div>
                <div className="action-list"
                    style={{
                        padding: "10px",
                        backgroundColor: 'rgb(245 245 245)'
                    }}
                >
                    <div className="action-item row">
                        <label className='col-3'><b>Önceliklendir</b></label>
                        <div className="action-controls col-8 d-flex">
                            <Input
                                type="number"
                                min="1"
                                max="9"
                                placeholder='1-9 arası bir sayı giriniz'
                                value={priority}
                                onChange={(e) => setPriority(e.target.value)}
                            />
                            <Button
                                variant="info"
                                size="sm"
                                onClick={handlePrioritySubmit}
                                disabled={isLoading}
                                className='ml-2 px-1'
                            >
                                İşlemi Onayla
                            </Button>
                        </div>
                    </div>
                    <div className="action-item row mt-4">
                        <label className='col-3'><b>PDI Emri</b></label>
                        <div className="action-controls col-8 d-flex">
                            <DateBox
                                min={new Date()}
                                type="date"
                                displayFormat="dd.MM.yyyy"
                                placeholder="Tarih Seçiniz"
                                value={pdiDate}
                                style={{ width: "100%" }}
                                onValueChanged={(e) => setPdiDate(e.value)}
                            />
                            <Button
                                variant="info"
                                size="sm"
                                onClick={handlePDISubmit}
                                disabled={isLoading}
                                className='ml-2 px-1'
                            >
                                İşlemi Onayla
                            </Button>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default QuickActionsModal; 